import { render, staticRenderFns } from "./BodyMessageTwo.vue?vue&type=template&id=d5c1e526&scoped=true&"
import script from "./BodyMessageTwo.vue?vue&type=script&lang=js&"
export * from "./BodyMessageTwo.vue?vue&type=script&lang=js&"
import style0 from "./BodyMessageTwo.vue?vue&type=style&index=0&id=d5c1e526&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c1e526",
  null
  
)

export default component.exports